import React, { useCallback, useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import { Offcanvas } from "react-bootstrap";
import DataTable from "react-data-table-component";

const OffCanvasHasilChecklist = ({ showHasilChecklist, handleCloseHasilChecklist, dataDisposisi, dataPrimer, jenisIzin }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const [listKritis, setListKritis] = useState([])
    const [listMayor, setListMayor] = useState([])
    const [listMinor, setListMinor] = useState([])

    const columnsKritis = [
        {
            name: 'Persyaratan',
            cell: row => (
                <div className="row">
                    <div className="col-12">
                        <b>{row['uraianChecklistHeader']}</b> -
                        &nbsp;&nbsp;{row['uraianCheckHeaderSub']} -
                        &nbsp;&nbsp;{row['uraianChecklistKomponen']}
                        &nbsp;&nbsp;{row['uraianChecklistKomponenSub']}
                    </div>
                </div>
            )
        },
    ]
    const columnsMayor = [
        {
            name: 'Persyaratan',
            cell: row => (
                <div className="row">
                    <div className="col-12">
                        <b>{row['uraianChecklistHeader']}</b> -
                        &nbsp;&nbsp;{row['uraianCheckHeaderSub']} -
                        &nbsp;&nbsp;{row['uraianChecklistKomponen']}
                        &nbsp;&nbsp;{row['uraianChecklistKomponenSub']}
                    </div>
                </div>
            )
        },
    ]
    const columnsMinor = [
        {
            name: 'Persyaratan',
            cell: row => (
                <div className="row">
                    <div className="col-12">
                        <b>{row['uraianChecklistHeader']}</b> -
                        &nbsp;&nbsp;{row['uraianCheckHeaderSub']} -
                        &nbsp;&nbsp;{row['uraianChecklistKomponen']}
                        &nbsp;&nbsp;{row['uraianChecklistKomponenSub']}
                    </div>
                </div>
            )
        },
    ]

    const fetchAllData = useCallback(async () => {
        if (!dataDisposisi?.noTugas || !dataPrimer?.nomorAju || (dataDisposisi.idDisposisi !== 8 && dataDisposisi.idDisposisi !== 9)) {
            return
        }
        try {
            const resInspeksi = await pbumkuService.getUmkuInspeksiDataByAjuAndNoSurat(dataPrimer.nomorAju, dataDisposisi.noTugas)
            if (resInspeksi.data !== null) {
                const result = await Promise.allSettled([
                    pbumkuService.listUmkuChecklistByIdInspeksiAndNilai(resInspeksi.data.idInspeksi, 0),
                    pbumkuService.listUmkuChecklistByIdInspeksiAndNilai(resInspeksi.data.idInspeksi, 2),
                    pbumkuService.listUmkuChecklistByIdInspeksiAndNilai(resInspeksi.data.idInspeksi, 3)
                ])
                const [resKritis, resMayor, resMinor] = result
                const getData = (res, fallback = []) =>
                    res.status === "fulfilled"
                        ? res.value?.data?.data ?? res.value?.data ?? fallback
                        : fallback;
                setListKritis(getData(resKritis))
                setListMayor(getData(resMayor))
                setListMinor(getData(resMinor))
            }
        } catch (error) {

        }

    }, [pbumkuService, dataDisposisi, dataPrimer])

    useEffect(() => {
        let isMounted = true
        if (!dataPrimer) return

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [dataPrimer, fetchAllData])

    return (
        <>
            <Offcanvas
                show={showHasilChecklist}
                onHide={handleCloseHasilChecklist}
                placement='end'
                scroll={true}
                backdrop={false}
            >
                <Offcanvas.Header closeButton>
                    <div className="d-flex align-items-center">
                        <h5>
                            Hasil Checklist {jenisIzin}
                        </h5>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="row">
                        <label className="col-sm-4 col-form-label-sm"><strong>Kritis</strong></label>
                    </div>
                    <div className="table-responsive border-bottom">
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columnsKritis}
                            data={listKritis}
                            highlightOnHover
                        />
                    </div>
                    <div className="row">
                        <label className="col-sm-4 col-form-label-sm"><strong>Mayor</strong></label>
                    </div>
                    <div className="table-responsive border-bottom">
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columnsMayor}
                            data={listMayor}
                            highlightOnHover
                        />
                    </div>
                    <div className="row">
                        <label className="col-sm-4 col-form-label-sm"><strong>Minor</strong></label>
                    </div>
                    <div className="table-responsive border-bottom">
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columnsMinor}
                            data={listMinor}
                            highlightOnHover
                        />
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default OffCanvasHasilChecklist